import { Component, EventEmitter, inject } from '@angular/core';
import { HasCloseEvent } from '../../../interfaces/has-close-event.interface';
import { GalleryService } from '../../../services/gallery.service';
import { ImageModel } from '../../../models/image.model';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-new-image',
  standalone: true,
  imports: [
    TranslocoDirective
  ],
  templateUrl: './new-image.component.html',
  styleUrl: './new-image.component.scss'
})
export class NewImageComponent implements HasCloseEvent {
  public closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>;

  private galleryService = inject(GalleryService);

  protected onImageAttached(event: any): void {
    if (event.target.files && event.target.files.length) {
      const files = event.target.files;
      Object.keys(files).forEach((key: string, i: number) => {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result?.toString()) {
            let image = new ImageModel({
              name: file.name,
              data: reader.result?.toString(),
              createdAt: new Date()
            });

            this.galleryService.uploadImage(image);
          }
        }
        reader.readAsDataURL(file);
      })
    }
    this.closeEvent.emit(true);
  }

  protected onCancel(): void {
    this.closeEvent.emit(true);
  }
}
